var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.5,
    height: 53.144,
    viewBox: "0 0 45.5 53.144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "help",
    d: "M43.611,3H9.389A4.888,4.888,0,0,0,4.5,7.889V42.111A4.888,4.888,0,0,0,9.389,47h9.778L26.5,54.333,33.833,47h9.778A4.9,4.9,0,0,0,48.5,42.111V7.889A4.9,4.9,0,0,0,43.611,3ZM28.944,42.111H24.056V37.222h4.889ZM34,23.167l-2.2,2.249a8.322,8.322,0,0,0-2.86,6.918H24.056V31.111a9.839,9.839,0,0,1,2.86-6.918l3.031-3.08a4.78,4.78,0,0,0,1.442-3.447,4.889,4.889,0,0,0-9.778,0H16.722a9.778,9.778,0,1,1,19.556,0A7.778,7.778,0,0,1,34,23.167Z",
    transform: "translate(-3.75 -2.25)",
    fill: "none",
    stroke: "#cb7620",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.3b6c7d6ee1d664786e0a15e6618971b3.svg";
export { ForwardRef as ReactComponent };